<div class="toast-wrapper fixed top-4 right-4 z-[9999] flex flex-col gap-3 w-full max-w-[350px] md:max-w-[400px] 3xl:max-w-[22vw] 3xl:top-[1.5vw] 3xl:right-[1.5vw] 3xl:gap-[0.8vw]">

  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast-item flex items-center justify-between p-4 rounded-xl shadow-2xl backdrop-blur-md border animate-fade-in transition-all duration-300 3xl:p-[1vw] 3xl:rounded-[0.8vw]"
         [ngClass]="{
           'bg-emerald-950/80 border-emerald-500/30 text-emerald-400': toast.type === 'success',
           'bg-rose-950/80 border-rose-500/30 text-rose-400': toast.type === 'error',
           'bg-amber-950/80 border-amber-500/30 text-amber-400': toast.type === 'warning',
           'bg-cyan-950/80 border-cyan-500/30 text-cyan-400': toast.type === 'info'
         }">

      <div class="flex items-center gap-3 3xl:gap-[0.6vw]">
        @if (toast.type === 'success') {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5 3xl:w-[1.2vw] 3xl:h-[1.2vw]"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
        } @else if (toast.type === 'error') {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5 3xl:w-[1.2vw] 3xl:h-[1.2vw]"><path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-5 h-5 3xl:w-[1.2vw] 3xl:h-[1.2vw]"><path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 1 1 1.059.935L10.5 14.312M12 7.75h.008v.008H12V7.75Z M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
        }

        <span class="text-sm font-medium tracking-wide 3xl:text-[0.9vw]">{{ toast.message }}</span>
      </div>

      <button (click)="toastService.remove(toast.id)" class="opacity-60 hover:opacity-100 transition-opacity ml-3 p-0.5 3xl:ml-[0.5vw]">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4 3xl:w-[1vw] 3xl:h-[1vw]"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>
      </button>

    </div>
  }
</div>
